import { Component, OnInit } from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { InvoiceManualCashDeskService } from "../../../services/invoice-cash-desk/invoice-manual-cash-desk.service";

@Component({
  selector: 'invoice-manual-cash-desk-edit',
  templateUrl: './invoice-manual-cash-desk-edit.component.html',
  styleUrls: ['./invoice-manual-cash-desk-edit.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoiceManualCashDeskService }]
})
export class InvoiceManualCashDeskEditComponent implements OnInit {



  ngOnInit(): void {

  }

  close(): void {
    history.back();
  }
}
